module.exports = __webpack_public_path__ + "static/media/refrigerator.13458e99.svg";